import { Component, OnInit } from '@angular/core';
import {
  GamesGroupService,
  GroupType,
  IGroupSummary,
  ProgressStatus,
  SortFn,
  PredictorGroupSummary,
  GamesGroupQuery,
  PredictorProcessStatus,
} from '@fgb/core';
import { sortBy } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Observable } from 'rxjs';

enum GAME_TAB {
  LIVE_UPCOMING = 0,
  RESULTS = 1,
}

@Component({
  selector: 'fgb-predictor-play-page',
  templateUrl: './predictor-play-page.component.html',
  styleUrl: './predictor-page.component.scss',
})
export class PredictorPlayPageComponent implements OnInit {
  gamesGroup$: Observable<PredictorGroupSummary[]>;
  groupType = GroupType.Predictor;
  liveUpcomingTab: boolean = false;
  filters: any[] = [];
  sort: SortFn[] = [];

  constructor(private gamesGroupService: GamesGroupService, private gamesGroupQuery: GamesGroupQuery) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchPredictorGroups();
  }

  onTabChage(tab: GAME_TAB): void {
    // logic was taken from games-group-list.component.ts
    const predictorFilter = (item: PredictorGroupSummary) => {
      const predictorGameGroupItem = item as PredictorGroupSummary;

      if (
        (predictorGameGroupItem &&
          predictorGameGroupItem.Status === ProgressStatus.NotStarted &&
          predictorGameGroupItem.ProcessStatus !== PredictorProcessStatus.Ready) ||
        (predictorGameGroupItem && predictorGameGroupItem.ProcessStatus === PredictorProcessStatus.Failed) ||
        (predictorGameGroupItem &&
          this.gamesGroupQuery.checkEndDate(String(predictorGameGroupItem.EndDate), String(predictorGameGroupItem.RequestTime)) &&
          (predictorGameGroupItem.ProcessStatus == PredictorProcessStatus.Ready ||
            predictorGameGroupItem.ProcessStatus == PredictorProcessStatus.Failed) &&
          predictorGameGroupItem.Status === ProgressStatus.NotStarted)
      ) {
        return false;
      }
      return true;
    };

    const defaultSort: SortFn[] = [
      (a, b) => {
        const statusOrder = ['resume', 'featured', 'play', 'comingSoon', 'processing', 'completed'];
        const getStatusIndex = (group: IGroupSummary) => {
          const predictorGroup = group as PredictorGroupSummary;
          if (predictorGroup.Status === ProgressStatus.NotStarted && predictorGroup.ComingSoon) {
            return statusOrder.indexOf('comingSoon');
          }
          if (
            predictorGroup.Status === ProgressStatus.NotStarted &&
            (predictorGroup as PredictorGroupSummary).ProcessStatus == PredictorProcessStatus.Ready &&
            group.Featured
          ) {
            return statusOrder.indexOf('featured');
          }
          const statusLabel = this.gamesGroupQuery.getPredictorFinalStatus(predictorGroup as PredictorGroupSummary);
          return statusOrder.indexOf(statusLabel.value);
        };
        return getStatusIndex(a) - getStatusIndex(b);
      },
    ];

    const isResultsConditions = (item: PredictorGroupSummary) => {
      const isCompleted = item.Status === ProgressStatus.Completed;
      const isNotStarted = item.Status === ProgressStatus.NotStarted;
      const isProcessing = item.ProcessStatus === PredictorProcessStatus.Processing;
      const isPastEndDate = new Date(item.RequestTime) > new Date(item.EndDate);
      const isProcessCompleted = item.ProcessStatus === PredictorProcessStatus.Processed;
      return (
        item.EntityGroupCompleted ||
        (isCompleted && isProcessing) ||
        (!isNotStarted && isPastEndDate) ||
        (isCompleted && isProcessCompleted)
      );
    };

    if (tab === GAME_TAB.LIVE_UPCOMING) {
      this.filters = [(item: PredictorGroupSummary) => !isResultsConditions(item), predictorFilter];
      this.sort = [...defaultSort, sortBy('StartDate', 'asc', { type: 'date' })];
      this.liveUpcomingTab = true;
    } else if (tab === GAME_TAB.RESULTS) {
      this.filters = [(item: PredictorGroupSummary) => isResultsConditions(item), predictorFilter];
      this.sort = [...defaultSort, sortBy('CompletionDate', 'desc', { type: 'date' })];
      this.liveUpcomingTab = false;
    }
  }
}

@Component({
  selector: 'fgb-predictor-page',
  templateUrl: './predictor-page.component.html',
  styleUrl: './predictor-page.component.scss',
})
export class PredictorPageComponent {}
